import { Reveal } from "../components/Reveal";
import { CONTACT } from "../lib/assets";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-aveden-black">
      {/* Top spacing for fixed nav */}
      <section className="pt-44 lg:pt-56 pb-20 lg:pb-28">
        <div className="mx-auto max-w-[1200px] px-6 sm:px-10 lg:px-16 text-center">
          <Reveal>
            <p className="font-sans text-[11px] tracking-[0.4em] uppercase text-aveden-gold mb-8">
              Contact
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-serif font-light text-aveden-white text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
              A private
              <br />
              conversation.
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="font-sans font-light text-aveden-gray text-base sm:text-lg leading-relaxed mt-8 max-w-xl mx-auto">
              For inquiries, please reach us directly. We respond to every
              message personally and in confidence.
            </p>
          </Reveal>
        </div>
      </section>

      <div className="mx-auto max-w-[1100px] px-6 sm:px-10 lg:px-16">
        <div className="gold-divider" />
      </div>

      {/* Contact details */}
      <section className="py-20 lg:py-32">
        <div className="mx-auto max-w-[1100px] px-6 sm:px-10 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-12">
            <Reveal>
              <div data-testid="contact-address">
                <h2 className="font-sans text-[11px] tracking-[0.32em] uppercase text-aveden-gold mb-7">
                  Mailing Address
                </h2>
                <address className="not-italic font-sans font-light text-aveden-gray text-base leading-loose">
                  {CONTACT.address.map((line) => (
                    <span key={line} className="block">
                      {line}
                    </span>
                  ))}
                </address>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div data-testid="contact-email">
                <h2 className="font-sans text-[11px] tracking-[0.32em] uppercase text-aveden-gold mb-7">
                  Email
                </h2>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="contact-email-link"
                  className="font-sans font-light text-aveden-gray hover:text-aveden-white text-base transition-colors duration-500"
                >
                  {CONTACT.email}
                </a>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div data-testid="contact-phone">
                <h2 className="font-sans text-[11px] tracking-[0.32em] uppercase text-aveden-gold mb-7">
                  Phone
                </h2>
                <a
                  href={`tel:${CONTACT.phoneHref}`}
                  data-testid="contact-phone-link"
                  className="font-sans font-light text-aveden-gray hover:text-aveden-white text-base transition-colors duration-500"
                >
                  {CONTACT.phone}
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
